"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleErrorsAsText = exports.handleValidation = exports.handleResponseMessage = exports.handleHttpError = exports.handleInternalError = exports.handleConflict = exports.handleForbidden = exports.handleUnauthorized = exports.handleNotFound = exports.handleJsError = exports.handleLegacyAnyError = exports.handleAnyError = exports.createErrorHandler = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _rxjs = require("rxjs");

var _ramda = require("ramda");

var _utils = require("../utils");

var _types = require("../types");

/**
 * Function that creates error handlers.
 *
 * @template Arg0, Arg1.
 * @param {HandlerTypes} type - Error handler type.
 * @param {(arg0: TAnyResponseError) => ([boolean, Arg0, Arg1] | [boolean, Arg0])} fn - Function that receive response
 * error and returns array where first element is `isHandled` flag
 * and other two are arguments that will be passed to action handlers.
 * @returns {IErrorHandler<Arg0, Arg1>}
 * @example
 */
var createErrorHandler = function createErrorHandler(type, fn) {
  return function () {
    for (var _len = arguments.length, actionCreatorsOrAction = new Array(_len), _key = 0; _key < _len; _key++) {
      actionCreatorsOrAction[_key] = arguments[_key];
    }

    var handler = function handler(response) {
      var _fn = fn(response),
          _fn2 = (0, _slicedToArray2["default"])(_fn, 3),
          isHandled = _fn2[0],
          arg0 = _fn2[1],
          _fn2$ = _fn2[2],
          arg1 = _fn2$ === void 0 ? undefined : _fn2$;

      if (isHandled) {
        return _rxjs.of.apply(void 0, (0, _toConsumableArray2["default"])((0, _utils.actionHandlersToActions)(actionCreatorsOrAction, arg0, arg1)));
      }

      return (0, _rxjs.of)();
    };

    handler.type = type;
    return handler;
  };
};

exports.createErrorHandler = createErrorHandler;

var isStatus = function isStatus(value) {
  return (0, _ramda.propSatisfies)((0, _ramda.equals)(value), 'status');
};

var isStatusExists = (0, _ramda.propSatisfies)((0, _ramda.complement)(_ramda.isNil), 'status');

var isStatusGte = function isStatusGte(value) {
  return (0, _ramda.propSatisfies)((0, _ramda.gte)(_ramda.__, value), 'status');
};

var isValidationErrorsExists = (0, _ramda.pathSatisfies)((0, _ramda.complement)(_ramda.isNil), ['error', 'errors']);
var getValidationErrors = (0, _ramda.pathOr)({}, ['error', 'errors']);
var isResponseMessageExists = (0, _ramda.pathSatisfies)((0, _ramda.complement)(_ramda.isNil), ['error', 'message']);
var getResponseMessage = (0, _ramda.pathOr)('', ['error', 'message']);
var getLegacyValidationErrors = (0, _ramda.propOr)({}, 'errors');
/**
 * Will be called and returns actions for every error,
 * and pass `response.error.errors` to the first argument and `response` to the second.
 *
 * @type {IErrorHandler<TErrors, TAnyResponseError>}
 */

var handleAnyError = createErrorHandler(_types.HandlerTypes.AnyError, (0, _ramda.juxt)([_ramda.T, getValidationErrors, _ramda.identity]));
/**
 * Will be called and returns actions for every error,
 * and pass `response.errors` to the first argument and `response` to the second.
 *
 * @type {IErrorHandler<TErrors, TAnyResponseError>}
 */

exports.handleAnyError = handleAnyError;
var handleLegacyAnyError = createErrorHandler(_types.HandlerTypes.AnyError, (0, _ramda.juxt)([_ramda.T, getLegacyValidationErrors, _ramda.identity]));
/**
 * Will be called and return actions only on javascript errors,
 * and pass catch error as a first argument to action handlers.
 *
 * @type {IErrorHandler<Error>}
 * @example
 */

exports.handleLegacyAnyError = handleLegacyAnyError;
var handleJsError = createErrorHandler(_types.HandlerTypes.Js, (0, _ramda.juxt)([(0, _ramda.complement)(isStatusExists), function (error) {
  return error;
}]));
/**
 * Will be called and return actions when status of response equals to 404,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleJsError = handleJsError;
var handleNotFound = createErrorHandler(_types.HandlerTypes.NotFound, (0, _ramda.juxt)([isStatus(404), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when status of response equals to 40`,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleNotFound = handleNotFound;
var handleUnauthorized = createErrorHandler(_types.HandlerTypes.Unauthorized, (0, _ramda.juxt)([isStatus(401), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when status of response equals to 403,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleUnauthorized = handleUnauthorized;
var handleForbidden = createErrorHandler(_types.HandlerTypes.Forbidden, (0, _ramda.juxt)([isStatus(403), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when status of response equals to 409,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleForbidden = handleForbidden;
var handleConflict = createErrorHandler(_types.HandlerTypes.Conflict, (0, _ramda.juxt)([isStatus(409), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when status of response more or equal to 500,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleConflict = handleConflict;
var handleInternalError = createErrorHandler(_types.HandlerTypes.InternalServerError, (0, _ramda.juxt)([isStatusGte(500), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when status of response more or equal to 400,
 * it puts failed response as a first argument to action handlers.
 *
 * @type {IErrorHandler<Exclude<TAnyResponseError, Error>>}
 * @example
 */

exports.handleInternalError = handleInternalError;
var handleHttpError = createErrorHandler(_types.HandlerTypes.AnyServerError, (0, _ramda.juxt)([isStatusGte(400), function (res) {
  return res;
}]));
/**
 * Will be called and return actions when meet `response.error.message` in response,
 * and put this message as first argument to action handlers.
 *
 * @type {IErrorHandler<string>}
 */

exports.handleHttpError = handleHttpError;
var handleResponseMessage = createErrorHandler(_types.HandlerTypes.ResponseMessage, (0, _ramda.juxt)([isResponseMessageExists, getResponseMessage])); // export const handleLegacyResponseMessage

/**
 * Will be called and return actions when met `response.error.errors` in response,
 * and put this errors as first argument to action handlers.
 *
 * @type {IErrorHandler<TErrors>}
 */

exports.handleResponseMessage = handleResponseMessage;
var handleValidation = createErrorHandler(_types.HandlerTypes.Validation, (0, _ramda.juxt)([isValidationErrorsExists, getValidationErrors]));
/**
 * Will be called the same with `handlers.handleValidation` but transform error object to message text.
 *
 * @type {IErrorHandler<string, undefined>}
 * @example
 */

exports.handleValidation = handleValidation;
var handleErrorsAsText = createErrorHandler(_types.HandlerTypes.Validation, (0, _ramda.juxt)([(0, _ramda.pathSatisfies)((0, _ramda.pipe)(_ramda.keys, _ramda.length, (0, _ramda.gt)(_ramda.__, 0)), ['error', 'errors']), function (response) {
  return (0, _ramda.pipe)((0, _ramda.pathOr)({}, ['error', 'errors']), _ramda.values, (0, _ramda.map)((0, _ramda.when)(Array.isArray, (0, _ramda.join)('. '))), (0, _ramda.join)('\n'))(response);
}]));
exports.handleErrorsAsText = handleErrorsAsText;